import DashboardContent from "page_components/admin/dashboard/Content";
import DashboardProvider from "context/admin/dashboard";

const Dashboard = () => {
  return (
    <DashboardProvider>
      <DashboardContent />
    </DashboardProvider>
  );
};

export default Dashboard;
